<template>
  <transition name="el-zoom-in-top">
    <div class="pg-top-remind" v-if="success?.length > 0 || errors?.length > 0">
      <Alert
        class="pg-top-remind__success"
        type="success"
        show-icon
        :closable="successClosable"
        @close="successClose"
        v-if="success?.length > 0"
      >
        <template #title>
          <span class="pg-top-remind__success--content">
            已生成<span style="color: #ff1212">{{ success.length }}</span
            >{{ success[0].bizName }}：
            <span v-for="(item, index) in success" :key="index">
              <span class="pg-top-remind__success--link" @click="getOrderRouterData(item)">{{
                item.code
              }}</span>
            </span>
          </span>
        </template>
      </Alert>
      <div v-if="errors?.length > 0" class="pg-top-remind__errors">
        <span
          >存在错误/警告共<span style="color: black">{{ errors.length }}</span
          >条</span
        >
        <ElButton type="text" @click="showErrorsModal(true)">立即查看</ElButton>
        <CollapseTransition>
          <div v-show="showErrors" class="pg-top-remind__errors-error-box">
            <div class="pg-top-remind__errors-error-box-box">
              <div class="pg-top-remind__errors-error-box-title">
                <div>
                  报错/警告(<span style="color: #ff1212">{{ errorNum }}</span
                  >/<span style="color: #ff8c00">{{ warnNum }}</span
                  >)
                </div>
                <a href="javascript:void(0)">
                  <i class="ivu-icon-icon-pg-close" @click="showErrorsModal(false)" />
                </a>
              </div>
              <div class="pg-top-remind__errors-error-box-content">
                <template v-for="(eItem, j) in errors">
                  <Alert
                    class="pg-top-remind__errors-error-box-content-alert"
                    v-if="eItem.message"
                    :closable="false"
                    show-icon
                    :type="getType(eItem)"
                    :key="j"
                  >
                    <template #title>
                      <span
                        v-if="eItem.row && !eItem.interactError && eItem.row !== -1"
                        :class="{ link: showHandleBtn }"
                        @click="gotoTable(eItem)"
                      >
                        第{{ eItem.row }}行
                      </span>
                      <span v-if="eItem.row != -1" style="color: #005fff">：</span>
                      {{ eItem.message }}
                    </template>
                  </Alert>
                </template>
              </div>
            </div>
          </div>
        </CollapseTransition>
      </div>
    </div>
  </transition>
</template>
<script setup>
import { Alert } from 'element-ui'
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition'
import { get } from '../../../utils/index'
import { useRouter } from 'vue-router/composables'
import { ref, computed, watch } from 'vue'

const props = defineProps({
  errors: Array,
  success: Array,
  showHandleBtn: Boolean,
  successClosable: {
    type: Boolean,
    default: false,
  },
})
const emit = defineEmits(['on-row', 'success-close'])

const router = useRouter()
const getOrderRouterData = async (item) => {
  const [res] = await get('~static/mock/orderTypeRouter.json')
  if (res) {
    const name = res.data?.[item.bizCode]?.name
    if (!name) {
      console.error('路由不存在')
      return
    }
    router.push({ name, query: { id: item.id } })
  }
}

const errorNum = computed(() => props.errors?.filter?.((im) => im.level === 1)?.length)
const warnNum = computed(() => props.errors?.filter?.((im) => im.level === 3)?.length)
const showErrors = ref(true)
const showErrorsModal = (val) => {
  showErrors.value = val
}
watch(
  () => props.errors,
  () => (showErrors.value = true)
)
const getType = (item) => {
  let remindStatus = null
  if (!item) return null
  switch (item.level) {
    case 1:
      remindStatus = 'error'
      break
    case 3:
      remindStatus = 'warning'
      break
    case 5:
      remindStatus = 'info'
      break
    case 7:
      remindStatus = 'success'
      break
  }
  return remindStatus
}
const gotoTable = (item) => {
  if (!props.showHandleBtn) return
  emit('on-row', item.row)
}

const successClose = () => {
  emit('success-close')
}
</script>
<style lang="scss">
@import '../style/top-remind.scss';
</style>
